import { createAction } from '@reduxjs/toolkit';
import { ISkill } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_SKILLS } from '../../../../common';

export const setSkills = createAction<ISkill[]>(
  `${MN_SKILLS}/${TYPE_LIST}/${ACT_SET}`,
);
